import { type ReactElement } from 'react'
import { cn } from '@util'
import { Group, Text } from '@mantine/core'
import { useTranslation } from '@front/model'
import { TButton } from '../buttons'
import { MAX_ZOOM, MIN_ZOOM } from './graphViewportHandlers'
import classes from './graphViewport.module.css'

type ZoomControlsProps = {
  docked?: boolean
  zoom: number
  onZoomIn: () => void
  onZoomOut: () => void
  onReset: () => void
}

export const ZoomControls = ({ docked, zoom, onZoomIn, onZoomOut, onReset }: ZoomControlsProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Group gap='xs' className={cn(classes.zoomControls, docked && classes.docked)}>
      <TButton
        buttonType='icon-rounded'
        disabled={zoom <= MIN_ZOOM}
        icon='remove'
        tooltip={t('Zoom out')}
        variant='gray'
        onClick={onZoomOut}
      />
      <Text size='sm' c='dimmed' ta='center' w={40}>
        {Math.round(zoom * 100)}%
      </Text>
      <TButton
        buttonType='icon-rounded'
        disabled={zoom >= MAX_ZOOM}
        icon='add'
        tooltip={t('Zoom in')}
        variant='gray'
        onClick={onZoomIn}
      />
      <TButton
        buttonType='icon-rounded'
        icon='restart_alt'
        tooltip={t('Fit to view')}
        variant='gray'
        onClick={onReset}
      />
    </Group>
  )
}
